export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export const parseDateFromStr = (str: string) => {
  const [day, month, year] = str.split('/')
  return new Date(+year, +month - 1, +day)
}

export const hasRemainder = (value: number) => value % 1 === 0

export const toFixedNumber = (value: number, fixed = 2): number => {
  const factor = Math.pow(10, fixed)
  return Math.round(value * factor) / factor
}
